/**
 * @generated SignedSource<<39a903f2da4bf638cda30ce62589e61c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type JiraAssignee_resourceTagKeys$data = {
  readonly jiraAssigneeResourceTagKeys: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly key: string;
      };
    }>;
  };
  readonly " $fragmentType": "JiraAssignee_resourceTagKeys";
};
export type JiraAssignee_resourceTagKeys$key = {
  readonly " $data"?: JiraAssignee_resourceTagKeys$data;
  readonly " $fragmentSpreads": FragmentRefs<"JiraAssignee_resourceTagKeys">;
};

import JiraAssigneeResourceTagKeysPaginationQuery_graphql from './JiraAssigneeResourceTagKeysPaginationQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = [
  "jiraAssigneeResourceTagKeys"
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": 100,
      "kind": "LocalArgument",
      "name": "count"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cursor"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "filter"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "count",
        "cursor": "cursor",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "count",
          "cursor": "cursor"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [],
      "operation": JiraAssigneeResourceTagKeysPaginationQuery_graphql
    }
  },
  "name": "JiraAssignee_resourceTagKeys",
  "selections": [
    {
      "alias": "jiraAssigneeResourceTagKeys",
      "args": [
        {
          "kind": "Variable",
          "name": "filterElement",
          "variableName": "filter"
        }
      ],
      "concreteType": "ResourceTagKeyConnection",
      "kind": "LinkedField",
      "name": "__JiraAssignee__jiraAssigneeResourceTagKeys_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ResourceTagKeyEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ResourceTagKey",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "key",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})();

(node as any).hash = "83a1a2b8c75b060a099d59e9605b0c86";

export default node;
